/**
 * Complete Decision Task API
 *
 * Records the learner's chosen option on a decision item so the
 * ProgressionEngine opens the matching value-mode conditional edge.
 * POST /api/path-items/{itemId}/complete-decision-task
 */

import axiosInstance from "../axiosInstance";

export interface CompleteDecisionTaskRequest {
  enrollmentId: number;
  /** The chosen decision option key (must be one of the item's options). */
  choice: string;
}

export interface CompleteDecisionTaskResponse {
  completed: boolean;
  completedAt: string;
  choice: string;
  alreadyCompleted: boolean;
  pathProgress: {
    percentage: number;
    pathComplete: boolean;
  };
}

export const completeDecisionTask = async (
  pathItemId: number,
  request: CompleteDecisionTaskRequest,
): Promise<CompleteDecisionTaskResponse> => {
  const response = await axiosInstance.post<CompleteDecisionTaskResponse>(
    `/api/path-items/${pathItemId}/complete-decision-task`,
    request,
  );

  return response.data;
};
